<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Configuration Manager</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngConfigurationManagerForm" #ngform="ngForm" id="configurationManagerForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="table-fields">
                <div>
                  <label>Configuration Selection</label>
                    <table>
                      <caption>
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Active</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let el of configurationController.configurationList; let i = index"
                          (click)="selectRow(i)"
                          [class.highlighted]="el.isselected"
                        >
                          <td>{{ el.name }}</td>
                          <td>{{ el.active }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="btn">
                      <!--<a disabled (click)="cloneConfiguration()">Clone</a>-->
                      <a *ngIf="this.projectService.activeProject.name == 'Default'" (click)="activateConfiguration()">Activate</a>
                      <!--<a (click)="deleteConfiguration()">Delete</a>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <!-- <button
              type="submit"
              [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
              (click)="saveConfiguration(); ngForm.reset()"
              [disabled]="!ngForm.form.valid"
            >
              Save
            </button>
            <a
              class="gray"
              href="#"
              type="reset"
              value="Cancel"
              (click)="cancelConfiguration()"
              >Cancel</a
            > -->
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
